exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_object-gops.js
// module id = dqPc
// module chunks = 0